import WorkflowRunsSummaryTile from '../components/tiles/WorkflowRunsSummaryTile';
import AppInsightsSummaryTile from '../components/tiles/AppInsightsSummaryTile';
import ServiceBusSummaryTile from '../components/tiles/ServiceBusSummaryTile';
import E2eResultsSummaryTile from '../components/tiles/E2eResultsSummaryTile';
import type { Env } from '../types';

const ENV_INTROS: Record<Env, string> = {
  test: 'TEST — integration testing. Currently sharing DEV backends during estate build-out.',
  dev: 'DEV — long-running development environment.',
  uat: 'UAT — user acceptance testing. Changes here are candidate for production.',
  prod: 'PROD — live production. Changes should only come via a release pipeline.',
};

// Overview page: headline numbers only. Each tile links through to a
// detail page where the full tables and drill-down lists live, so the
// overview stays scannable on any screen size.
export default function EnvDashboard({ env }: { env: Env }) {
  return (
    <div className="page">
      <h2>{env.toUpperCase()} environment</h2>
      <p>{ENV_INTROS[env]}</p>

      <section className="tile-grid overview-grid">
        <WorkflowRunsSummaryTile env={env} detailsHref={`/${env}/workflows`} />
        <AppInsightsSummaryTile env={env} compact detailsHref={`/${env}/app-insights`} />
        <ServiceBusSummaryTile env={env} compact detailsHref={`/${env}/service-bus`} />
        <E2eResultsSummaryTile env={env} detailsHref={`/${env}/e2e-results`} />
      </section>
    </div>
  );
}
